import axios from "../../../utils/axios";

/**
 * Повертає масив бренів
 * @returns 
 */
export const getBrands = async () => {
    try {
        const response = await axios(`../plugin/market/dir/brands`);
        return response?.data?.brands||null;
    } catch(e){
        console.log(e);
        return null;
    }
}